import type { IPost } from 'types/interfaces/ITypes'

export function getFirstPagePostsFromInfiniteData(d: any): IPost[] {
  if (!d) return []

  // flat array fallback
  if (Array.isArray(d.posts)) return d.posts as IPost[]

  const pages = d.pages
  if (!Array.isArray(pages) || pages.length === 0) return []

  const p0 = pages[0]

  const a = p0?.page?.data?.data
  if (Array.isArray(a)) return a as IPost[]

  const b = p0?.posts
  if (Array.isArray(b)) return b as IPost[]

  const c = p0?.data
  if (Array.isArray(c)) return c as IPost[]

  return []
}
